const targetUrl = "https://www.evoqueinterior.com/pages/reviews";
const arrowIcon = "https://www.evoqueinterior.com/cdn/shop/files/Arrow_right.svg?v=1766054744";

function convertToLinkWithArrow() {
  const element = document.querySelector(".quoli-carousel-header p");

  if (element && !element.querySelector("a")) {
    const link = document.createElement("a");
    link.href = targetUrl;
    link.target = "_blank";
    link.style.display = "inline-flex";
    link.style.alignItems = "center";
    link.style.gap = "6px";
    link.style.textDecoration = "none";
    link.style.color = "inherit";

    // Text
    const textSpan = document.createElement("span");
    textSpan.textContent = element.textContent;

    // Arrow Image
    const arrowImg = document.createElement("img");
    arrowImg.src = arrowIcon;
    arrowImg.alt = "Arrow";
    arrowImg.style.width = "16px";
    arrowImg.style.height = "auto";

    // Append
    link.appendChild(textSpan);
    link.appendChild(arrowImg);

    element.textContent = "";
    element.appendChild(link);
  }
}

// Run initially
convertToLinkWithArrow();

// Watch for dynamic DOM updates
const observer = new MutationObserver(convertToLinkWithArrow);
observer.observe(document.body, {
  childList: true,
  subtree: true
});

